/**
 * The debt reminder a CUSTOMER receives on WhatsApp — sent from the ნისია page
 * and, since 2026-09-30, from the owner's Telegram („📒 ვალები"). One text in
 * one place, so the two never drift. Georgian whatever the till or the chat
 * speaks: it is written to the customer, like the receipt.
 */

/** wa.me needs digits with the country code; Georgian mobiles are 5XXXXXXXX. */
export function waPhone(raw: string | null | undefined): string | null {
  if (!raw) return null
  const d = raw.replace(/\D/g, '')
  if (d.startsWith('995') && d.length >= 12) return d
  if (d.length === 9 && d.startsWith('5')) return '995' + d
  return null
}

export function reminderText(c: { name: string; balance: number }, shop: string, bankDetails: string): string {
  const bank = bankDetails.trim()
  return (
    `გამარჯობა ${c.name}, ${shop}-დან შეგახსენებთ: ` +
    `თქვენი მიმდინარე ნისიის ნაშთია ${c.balance.toFixed(2)} ლარი. ` +
    `თანხის დაფარვა შეგიძლიათ მაღაზიაში${bank ? ` ან გადმორიცხვით: ${bank}` : ''}. გმადლობთ!`
  )
}

/** The WhatsApp chat with the reminder already typed — the customer sees nothing until it is sent. */
export const whatsAppLink = (phone: string, text: string) => `https://wa.me/${phone}?text=${encodeURIComponent(text)}`
